export default {
  operation: {
    plural: {
      itself: 'Operațiuni',
    },
  },
};
